// import moment from 'moment';

export const USER_KEY = 'user';
export const LANG_KEY = 'lang';
export const STATE = 'state';
export const POPUP_KEY = 'popup';
const storage = window.localStorage;

export default {
  getUser() {
    const user = JSON.parse(storage.getItem(USER_KEY));
    if (!user) return null;
    return user;
  },
  setUser(data) {
    storage.setItem(USER_KEY, JSON.stringify(data));
  },
  removeUser() {
    storage.removeItem(USER_KEY);
  },
  getLang() {
    return storage.getItem(LANG_KEY);
  },
  setLang(lang) {
    storage.setItem(LANG_KEY, lang);
  },
  removeLang() {
    storage.removeItem(LANG_KEY);
  },
  getShowExplorePopup() {
    const user = this.getUser();
    return user.showExplorePopup;
  },
  setShowExplorePopup(showExplorePopup) {
    const user = this.getUser();
    user.showExplorePopup = showExplorePopup;
    storage.setItem(USER_KEY, JSON.stringify(user));
  },
  getUserProfile() {
    const user = this.getUser();
    const userProfile = {
      guid: user && user.guid,
      id: user && user.id,
      name: user && user.name,
      roles: user && user.roles,
      showExplorePopup: user && user.showExplorePopup,
      groupName: user && user.groupName,
      regdDatetime: user && user.regdDatetime,
      tempRegisteredDateTime: user && user.tempRegisteredDateTime,
    };
    return userProfile;
  },
  getAppIds() {
    const appIds = JSON.parse(storage.getItem('appIds'));
    if (!appIds) return null;
    return appIds;
  },
  getAppTitles() {
    const appTitles = JSON.parse(storage.getItem('appTitles'));
    if (!appTitles) return null;
    return appTitles;
  },
  setAppIds(data) {
    if (!data) storage.removeItem('appIds');
    else storage.setItem('appIds', JSON.stringify(data));
  },
  setAppTitles(data) {
    if (!data) storage.removeItem('appTitles');
    else storage.setItem('appTitles', JSON.stringify(data));
  },
  setNoticePopup(popup) {
    storage.setItem(POPUP_KEY, popup);
  },
  getNoticePopup() {
    return storage.getItem(POPUP_KEY);
  },
  setNoAppsPopup(popup) {
    storage.setItem('noAppsPopup', popup);
  },
  getNoAppsPopup() {
    return storage.getItem('noAppsPopup');
  },
  setOtherUserDetails(data) {
    if (!data) storage.removeItem('userDetails');
    else storage.setItem('userDetails', JSON.stringify(data));
  },
  getOtherUserDetails() {
    const userDetails = JSON.parse(storage.getItem('userDetails'));
    if (!userDetails) return null;
    return userDetails;
  },
  setAdminAppTitles(data) {
    if (!data) storage.removeItem('adminAppTitles');
    else storage.setItem('adminAppTitles', JSON.stringify(data));
  },
  getAdminAppTitles() {
    const adminAppTitles = JSON.parse(storage.getItem('adminAppTitles'));
    if (!adminAppTitles) return null;
    return adminAppTitles;
  },
  setRegionList(data) {
    if (!data) storage.removeItem('regionList');
    else storage.setItem('regionList', JSON.stringify(data));
  },
  getRegionList() {
    const regionList = JSON.parse(storage.getItem('regionList'));
    if (!regionList) return null;
    return regionList;
  },
  setAreaList(data) {
    if (!data) storage.removeItem('areaList');
    else storage.setItem('areaList', JSON.stringify(data));
  },
  getAreaList() {
    const areaList = JSON.parse(storage.getItem('areaList'));
    if (!areaList) return null;
    return areaList;
  },
  setAreaRegionList(data) {
    if (!data) storage.removeItem('areaRegionList');
    else storage.setItem('areaRegionList', JSON.stringify(data));
  },
  getAreaRegionList() {
    const areaRegionList = JSON.parse(storage.getItem('areaRegionList'));
    if (!areaRegionList) return null;
    return areaRegionList;
  },
  setRegion(data) {
    if (!data) storage.removeItem('region');
    else storage.setItem('region', JSON.stringify(data));
  },
  getRegion() {
    const region = JSON.parse(storage.getItem('region'));
    if (!region) return null;
    return region;
  },
  setInch(data) {
    if (!data) storage.removeItem('inch');
    else storage.setItem('inch', JSON.stringify(data));
  },
  getInch() {
    const inch = JSON.parse(storage.getItem('inch'));
    if (!inch) return null;
    return inch;
  },
  setRelease(data) {
    if (!data) storage.removeItem('release');
    else storage.setItem('release', JSON.stringify(data));
  },
  getRelease() {
    const release = JSON.parse(storage.getItem('release'));
    if (!release) return null;
    return release;
  },
  setArea(data) {
    if (!data) storage.removeItem('area');
    else storage.setItem('area', JSON.stringify(data));
  },
  getArea() {
    const area = JSON.parse(storage.getItem('area'));
    if (!area) return null;
    return area;
  },
  removePopUp() {
    storage.removeItem('popup');
  },
  setState(ssoState) {
    if (!ssoState) storage.removeItem('state');
    else storage.setItem('state', ssoState);
  },
  getState() {
    return storage.getItem('state');
  },
};
